import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  PaginatedSpace,
  QuerySearchSpacesArgs,
} from '@tribeplatform/gql-client/types'
import { PaginatedSpaceFields } from '@tribeplatform/gql-client/types/generated'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { getInfiniteSearchSpacesKey } from '@tribeplatform/react-sdk/utils/keys'

type Props = {
  variables: QuerySearchSpacesArgs
  fields?: PaginatedSpaceFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedSpace>
}

export const useInfiniteSearchSpaces = ({
  variables,
  fields,
  useInfiniteQueryOptions,
}: Props) => {
  const { client } = useTribeClient()

  return useInfiniteQuery<PaginatedSpace, ClientError>(
    getInfiniteSearchSpacesKey({ variables, fields }),
    ({ pageParam: after }) =>
      client.searchSpaces({ after, ...variables }, fields),
    {
      refetchOnWindowFocus: false,
      ...useInfiniteQueryOptions,
    },
  )
}
